import React from 'react';

import { flagStyles } from '../settings';

const SvgPE = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4128px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPE;
